<script>
export default {
  name: 'Title',
};
</script>

<template>
  <v-row>
    <v-col class="text-center">
      <h1 class="launchpad__title"><slot /></h1>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
.launchpad__title {
  margin-top: 0;
}
</style>
